


























































































































































































































































































































































































































































































































































































































































































































































































































































const namespace = 'workshopsSchedule';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import RestResource from '@/modules/api/RestResource';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import IPaymentRequest from '@/modules/form/interfaces/IPaymentRequest';
import Guideline from '@/modules/workshops-schedule/components/Guideline.vue';
import { GuidelineStep } from '@/modules/workshops-schedule/components/Guideline.vue';
import CountrySelect from '@/modules/workshops-schedule/components/CountrySelect.vue';
import CalendarDropdownFilters from '@/modules/calendar/components/CalendarDropdownFilters.vue';
import CalendarPills from '@/modules/calendar/components/CalendarPills.vue';
import CalendarContent from '@/modules/calendar/components/CalendarContent.vue';
import { WeekDay, WeekSchedule, Workshop, Timeline } from '@/modules/workshops-schedule/models/weekScheduleModels';
import { Registration, AvailableTicketType } from '@/modules/workshops-schedule/models/formModels';
import { FormHelper } from '@/modules/workshops-schedule/models/logic/FormHelper';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { generateClientIP } from '@/utils/web';

import { countriesData } from './data/ISO_3166-1_countries_pl';

@Component({
    name: 'ScheduleBoard',
    components: {
        Guideline,
        CalendarDropdownFilters,
        CalendarPills,
        CalendarContent,
        ValidationProvider,
        ValidationObserver,
        CountrySelect,
    },
})
export default class ScheduleBoard extends Vue {
    @Getter('loading', { namespace }) private loading!: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace }) private setLoading: any;
    @Getter('isGuidelineVisible', { namespace: 'workshopsSchedule' }) private isGuidelineVisible!: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('showGuideline', { namespace }) private showGuideline: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('hideGuideline', { namespace }) private hideGuideline: any;
    @Getter('currentEventId', { namespace: 'form' }) private currentEventId!: number;
    @Getter('weekSchedule', { namespace }) private weekSchedule!: WeekSchedule;
    @Getter('weekDays', { namespace }) private weekDays!: WeekDay[];
    @Getter('workshops', { namespace }) private workshops!: Workshop[];
    @Getter('timeline', { namespace }) private timeline!: Timeline[];
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setEvents', { namespace: 'calendar' }) private setEvents: any;
    @Getter('getAllEvents', { namespace: 'calendar' }) private getAllEvents!: ICalendarData[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setWeekSchedule', { namespace }) private setWeekSchedule: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchAvaiableTicketTypes', { namespace }) private fetchAvaiableTicketTypes: any;
    @Action('fetchCurrentWeekDays', { namespace }) private fetchCurrentWeekDays: any;
    @Action('setFormDetails', { namespace }) private setFormDetails: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('loadFormStateForRegistration', { namespace }) private loadFormStateForRegistration!: any;
    @Getter('availableTicketsTypes', { namespace }) private availableTicketsTypes!: AvailableTicketType[];
    @Getter('availableTicketsIds', { namespace }) private availableTicketsIds!: number[];
    @Getter('selectedWorkshopsIds', { namespace }) private selectedWorkshopsIds!: number[];
    @Getter('selectedTicketsIds', { namespace }) private selectedTicketsIds!: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('tooglSelectedWorkshopId', { namespace }) private tooglSelectedWorkshopId: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('toogleSelectedTicket', { namespace }) private toogleSelectedTicket: any;
    private get cssVariables() {
        return (
            '--weekday-width:' +
            100 / this.weekSchedule.WeekDays.length +
            '%; ' +
            '--location-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations.length +
            '%; ' +
            '--room-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations[0].Rooms.length +
            '%; ' +
            '--schedule-board-container-height: 1000px;'
        );
    }

    public created() {
        window.addEventListener('scroll', this.collapsTickets);
    }
    public destroyed() {
        window.removeEventListener('scroll', this.collapsTickets);
    }

    //#region form
    private eventId = 0;
    private formStep = 1;
    private alertsVisible = false;
    private errors: any[] = [];
    private alerts: object[] = [];
    private isFormVisible = false;
    private acceptConditions = null;
    private formHelper = new FormHelper();
    private get countries() {
        const countries = countriesData
            .map((x: any) => ({ text: x.name_en, value: x.name_en }))
            .sort((x: any, y: any) => x.text.toLowerCase().localeCompare(y.value.toLowerCase()));
        // this.resources.unshift({ text: null, value: this.formField.Tooltip, Hidden: true });
        countries.unshift({ text: 'Polska', value: 'Poland' });
        return countries;
    }
    private sexItems = [
        { value: 1, text: this.getTranslation('userForm.male') },
        { value: 2, text: this.getTranslation('userForm.female') },
    ];
    private advanceLevelItems = [
        { value: 1, text: this.getTranslation('registrationForm.beginner') },
        { value: 2, text: this.getTranslation('registrationForm.intermediate') },
        { value: 3, text: this.getTranslation('registrationForm.advanced') },
        { value: 4, text: this.getTranslation('registrationForm.professional') },
    ];
    private dietTypeItems = [
        { value: 1, text: this.getTranslation('registrationForm.meat') },
        { value: 2, text: this.getTranslation('registrationForm.vegetarian') },
        { value: 3, text: this.getTranslation('registrationForm.vegan') },
    ];
    private arrivalDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zwf2022Thursday') },
        { value: 2, text: this.getTranslation('registrationForm.zwf2022Friday') },
    ];
    private departureDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zwf2022Sunday') },
        { value: 2, text: this.getTranslation('registrationForm.zwf2022Monday') },
    ];
    private howLongDancingItems = [
        { value: 1, text: this.getTranslation('registrationForm.lessThen1Year') },
        { value: 2, text: this.getTranslation('registrationForm.lessThen3Year') },
        { value: 3, text: this.getTranslation('registrationForm.lessThen5Year') },
        { value: 4, text: this.getTranslation('registrationForm.moreThen5Year') },
    ];
    private howMuchDancingItems = [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
    ];
    private tshirtSizeItems = [
        { value: 1, text: 'S' },
        { value: 2, text: 'M' },
        { value: 3, text: 'L' },
        { value: 4, text: 'XL' },
    ];

    private collapsTickets() {
        const availableTicketsVertical = document.getElementById(`available-tickets-vertical`);
        const availableTickets = document.getElementById(`available-tickets`);
        const scheduleGuideline = document.getElementById(`schedule-guideline`);
        const availableTicketsPosition =
            document.getElementById('available-tickets-vertical')?.getBoundingClientRect().y ?? 0;
        if (availableTicketsPosition < 0) {
            availableTicketsVertical?.classList.add('ticket-collapsed');
            availableTickets?.classList.add('ticket-fixed');
            scheduleGuideline?.classList.add('schedule-guideline-scrolled');
        } else {
            availableTicketsVertical?.classList.remove('ticket-collapsed');
            availableTickets?.classList.remove('ticket-fixed');
            scheduleGuideline?.classList.remove('schedule-guideline-scrolled');
        }
    }

    public async mounted() {
        const eventId =
            this.$route.query.e ||
            this.$route.query.eventId ||
            this.$route.query.EventId ||
            this.currentEventId.toString();
        if (eventId !== undefined) {
            this.eventId = +eventId as number;
        }

        const eventParticipantGuid = (this.$route.query.erid == undefined ? null : this.$route.query.erid) as
            | string
            | null;
        let updateFirstAndLastName = false;
        if (this.$route.query.u == '1' && eventParticipantGuid != null) {
            updateFirstAndLastName = true;
        }

        generateClientIP();

        await this.fetchCurrentWeekDays();
        await this.fetchAvaiableTicketTypes();

        // const animation = sync(['elevated']);
        // animation.start();
        this.registartionsResource.$on('resourceCreated', this.onRegistartionCreated);
        this.registartionsResource.baseUrl = this.apiUrl + '/registrations/EventRegistrationForms';
        this.paymentsResource.$on('resourceCreated', this.onPaymentCreated);
        this.paymentsResource.baseUrl = this.apiUrl + '/payments/PaymentRequests';

        if (this.$route.query.paymentId) {
            this.hideGuideline();
            const id = this.$route.query.paymentId.toString();
            const status = this.$route.query.paymentStatus;
            if (status) {
                await this.paymentsResource.patchResource(id, { status: status });
            }

            const payment = await this.paymentsResource.getResource(id);
            if (payment.Status === 'CONFIRMED' || payment.Status === 'COMPLETED') {
                this.cleanUrlParameters();
                this.showSuccess(this.getTranslation('messages.Payment confirmed'));
            } else {
                this.showError(this.getTranslation('messages.Payment rejected'));
                if (payment && payment.EventRegistrationId && payment.EventRegistrationGuid) {
                    // this.cleanUrlParameters();
                    this.$router.push({
                        query: { i: payment.EventRegistrationId.toString(), g: payment.EventRegistrationGuid },
                    });
                }
            }
        } else {
            this.showGuideline();
        }

        if (this.isSessionContinuation) {
            const eventRegistrationId = +this.$route.query.i as number;
            const eventRegistrationGuid = this.$route.query.g as string;

            this.setFormDetails({
                eventRegistrationId: eventRegistrationId,
                eventRegistrationGuid: eventRegistrationGuid,
            });

            await this.fetchAvaiableTicketTypes();

            const form = await this.loadFormStateForRegistration();
            this.form = form as Registration;
            const selectedTicketsIds = [...new Set(this.form.ParticipantData.SelectedTickets.Value.map(x => x))];
            selectedTicketsIds.forEach(ticketTypeId => this.toogleTicketSelection(ticketTypeId));
            // this.cleanUrlParameters();
        } else if (this.isRecommendation) {
            const recommendedBy = this.$route.query.rec as string;
            this.form.ParticipantData.RecommendedBy.Value = recommendedBy;
            this.setFormDetails({
                recommendedBy: recommendedBy,
            });
            await this.fetchAvaiableTicketTypes();
        }

        if (updateFirstAndLastName) {
            this.form.ParticipantData.EventParticipantGuid.Value = eventParticipantGuid;
            this.form.ParticipantData.UpdateData.Value = true;
        }
    }

    private get isSessionContinuation() {
        return this.$route.query.g !== undefined && this.$route.query.i !== undefined;
    }

    private get isRecommendation() {
        return this.$route.query.rec !== undefined;
    }

    private cleanUrlParameters() {
        window.history.replaceState(null, '', '/');
    }

    private readonly SubmitEventRegistrationFormRequests = this.apiUrl + '/registrations/EventRegistrationForms';
    private registartionsResource: RestResource<Registration> = new RestResource<Registration>(
        this.SubmitEventRegistrationFormRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );
    private readonly PaymentRequests = this.apiUrl + '/payments/PaymentRequests';
    private paymentsResource: RestResource<IPaymentRequest> = new RestResource<IPaymentRequest>(
        this.PaymentRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );

    private form: Registration = this.formHelper.createEmptyRegistrationForm(this.eventId);

    private get ticketsSelected(): boolean {
        return this.selectedWorkshopsIds.length < 1;
    }

    private get eventParticipantSexTypeId(): number | null {
        return this.form.ParticipantData.SexTypeId.Value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.showError(data.error.message);
        } else {
            this.showError(this.getTranslation('messages.Cant submit your form'));
        }
    }

    private showError(message: string) {
        this.alerts.push({ type: 'error', message: message });
        this.alertsVisible = true;
    }

    private showWarning(message: string) {
        this.alerts.push({ type: 'warning', message: message });
        this.alertsVisible = true;
    }

    private showInfo(message: string) {
        this.alerts.push({ type: 'info', message: message });
        this.alertsVisible = true;
    }

    private showSuccess(message: string) {
        this.alerts.push({ type: 'success', message: message });
        this.alertsVisible = true;
    }

    private closeAlerts() {
        this.alertsVisible = false;
        this.alerts = [];
    }

    private showForm() {
        this.isFormVisible = true;
        this.hideGuideline();
        this.unpulsElement('available-tickets');
        this.unpulsElement('order-tickets-button');
    }
    private closeForm() {
        this.isFormVisible = false;
    }
    private async submit() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        if (!result) {
            return;
        }

        this.form.ParticipantData.EventId.Value = this.currentEventId;
        this.form.DancePartnerData.EventId.Value = this.currentEventId;
        this.form.ParticipantData.EventParticipantGuid.Value = (this.$route.query.erid == undefined
            ? null
            : this.$route.query.erid) as string | null;
        this.form.ParticipantData.UpdateData.Value = this.$route.query.u === '1';
        await this.registartionsResource.createNewResource(this.form);
    }
    private async availableTicketTypesLoaded(response: any) {
        // do nothing
    }
    private async onRegistartionCreated(response: any) {
        // this.$router.currentRoute.query;
        // let path = `${window.location.origin}${window.location.pathname}${this.$router.currentRoute.fullPath}`;
        let path = `${window.location.origin}${window.location.pathname}`;
        path = path.replace('//?', '?').replace('/?', '?');

        if (response.status === 'RegistrationPaid') {
            this.cleanUrlParameters();
            this.fetchAvaiableTicketTypes();
            this.showInfo(this.getTranslation('messages.Your registration is already paid'));

            return;
        }

        this.setFormDetails({
            eventRegistrationId: response.eventRegistrationId,
            eventRegistrationGuid: response.eventRegistrationGuid,
        });

        if (response.unavailableTicketsIds.length > 0) {
            response.unavailableTicketsIds.forEach((x: number) => this.toogleSelectedTicket(x));
            // reload the available tickets
            await this.fetchAvaiableTicketTypes();
            this.showInfo(this.getTranslation('messages.Some of the selected tickets are not available any more'));

            return;
        }

        const posType = this.form.ParticipantData.Country.Value === 'Poland' ? 'PayNow' : 'PayU';

        const payment = {
            EventRegistrationId: response.eventRegistrationId,
            EventRegistrationGuid: response.eventRegistrationGuid,
            ClientIp: this.clientIp,
            PosType: posType,
            // PosType: 'PayNow',
            // PosType: 'PayU',
            ContinueUrl: path,
        };

        const paymentResponse = await this.paymentsResource.createNewResource(payment);
        if (!paymentResponse) {
            this.showError(this.getTranslation('messages.Error during requesting payment'));
        }
    }

    private async onPaymentCreated(response: any) {
        const path = response.redirectUri;
        // window.open(path, '_blank');
        window.open(path, '_self');
    }

    private get clientIp() {
        let clientIp = localStorage.getItem('clientIp');
        if (clientIp === undefined || clientIp === null || clientIp === '' || clientIp === 'undefined') {
            clientIp = '127.0.0.1'; // fake IP in case of issuses with getting parameter that is required for the payent
        }

        return clientIp;
    }

    private clear() {
        this.formHelper.clearRegistrationForm(this.form);
        this.acceptConditions = null;

        this.selectedTicketsIds?.forEach(ticketId => {
            this.toogleSelectedTicket(ticketId);
            this.selectedTicketsIds.splice(this.selectedTicketsIds.indexOf(ticketId), 1);
        });
        this.form.ParticipantData.SelectedTickets.Value = [];

        (this.$refs.observer as any).reset();
        this.formStep = 1;
    }

    private async submitRegistrationForm() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        const errors = observer.errors;
        if (
            errors.firstName.length ||
            errors.lastName.length ||
            errors.email.length ||
            errors.phoneNumber.length ||
            errors.sex.length
        ) {
            this.formStep = 1;
        } else if (
            errors.country.length ||
            errors.city.length // ||
            // errors.contactMeVia.length ||
            // errors.facebook.length ||
            // errors.advanceLevel.length ||
            // errors.dietType.length ||
            // errors.arrivalDate.length ||
            // errors.departureDate.length ||
            // errors.howLongDancing.length ||
            // errors.howMuchDancing.length ||
            // errors.tshirtSize.length
        ) {
            this.formStep = 2;
        } else if (errors.selectedTicketsIds.length) {
            this.formStep = 3;
        } else if (
            errors.dancePartnerFirstName?.length ||
            errors.dancePartnerLastName?.length ||
            errors.dancePartnerEmail?.length ||
            errors.dancePartnerPhoneNumber?.length ||
            errors.dancePartnerSex?.length
        ) {
            this.formStep = 4;
        }
        this.form.ParticipantData.SelectedTickets.Value = this.selectedTicketsIds;
    }

    private choseTickets() {
        this.registrationFormModalMarathonPass = false;
        this.registrationFormModalReserveList = false;
        this.formStep = 3;
    }

    private goToNextFormStep() {
        if ((this.formStep == 3 && !this.form.IsForCouple) || (this.formStep == 4 && this.form.IsForCouple)) {
            this.validateTicketSelection();
        }
        this.formStep = this.formStep + 1;
    }

    private goToPreviousFormStep() {
        if (this.formStep > 0) {
            this.formStep = this.formStep - 1;
        }
    }

    private get reserveListTickets() {
        return this.tickets.filter(x => x.IsReserveList);
    }

    private validateTicketSelection() {
        const marathonPassId = this.marathonPassId;
        const marathonPassIsAvailable = this.tickets.filter(x => x.Id == marathonPassId && x.IsAvailable).length > 0;
        if (!this.selectedTicketsIds.includes(marathonPassId) && marathonPassIsAvailable) {
            this.registrationFormModalMarathonPass = true;
        }

        const reserveListTickets = this.reserveListTickets;
        if (reserveListTickets.filter(x => this.selectedTicketsIds.includes(x.Id)).length > 0) {
            this.registrationFormModalReserveList = true;
        }
    }

    private getTicketImage(ticketId: number) {
        switch (ticketId) {
            case 39:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Michael_Aline.jpg');
            case 40:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Anderson_Brenda.jpg');
            case 41:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Leo_Ana.jpg');
            case 43:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Master_Path.jpg');
            case 44:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Marti_Natalia.jpg');
            case 45:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Piotr_Patrycja.jpg');
            case 47:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lucas_Thayna.jpg');
            case 42:
            case 46:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Party.jpg');
            case 29:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Friday.jpg');
            case 30:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Saturday.jpg');
            case 31:
                return this.getImageUrl('/images/instruktorzy/Thumbnail_ZWF_Lunch_Sunday.jpg');
        }
    }

    private getTicketTitle(ticketId: number) {
        const tickets = this.availableTicketsTypes.filter(x => x.Id == ticketId);
        return tickets.length ? tickets[0].Name : '';
    }

    private getTranslation(key: string) {
        return this.$t(key).toString();
    }

    private get tickets() {
        let sexTypeId = this.form.ParticipantData.SexTypeId.Value;
        if (!sexTypeId) {
            sexTypeId = 1;
        }
        const ticketTypes = this.availableTicketsTypes.filter(
            x => x.SexTypeId === sexTypeId && x.IsVisible && !x.Name.includes('Lunch'),
        );
        return ticketTypes;
    }

    private get ticketsToSelect() {
        let sexTypeId = this.form.ParticipantData.SexTypeId.Value;
        if (!sexTypeId) {
            sexTypeId = 1;
        }
        const ticketTypes = this.availableTicketsTypes.filter(
            x => x.SexTypeId === sexTypeId && x.IsAvailable && x.IsVisible,
        );
        return ticketTypes;
    }
    //#endregion form

    private errorMessage = '';
    private errored = false;
    private registrationFormModalMarathonPass = false;
    private registrationFormModalReserveList = false;
    private guidelineSteps: GuidelineStep[] = [
        {
            Title: '',
            Message: this.getTranslation('guideline.guidelineSteps.step1.message'),
            OnLoad: () => {
                if (this.isGuidelineVisible) {
                    this.pulsElement('available-tickets');
                }
            },
            CloseButtonAction: () => {
                this.unpulsElement('available-tickets');
                // this.hideGuideline();
            },
        },
        {
            Title: '',
            Message: this.getTranslation('guideline.guidelineSteps.step2.message'),
            OnLoad: () => {
                this.unpulsElement('available-tickets');
                this.unpulsElement('order-tickets-button');
            },
            CloseButtonAction: () => {
                this.unpulsElement('available-tickets');
                // this.hideGuideline();
            },
        },
        // {
        //     Title: '',
        //     Message: this.getTranslation('guideline.guidelineSteps.step3.message'),
        //     OnLoad: () => {
        //         if (this.isGuidelineVisible) {
        //             this.pulsElement('order-tickets-button');
        //         }
        //     },
        //     CloseButtonAction: () => {
        //         this.unpulsElement('order-tickets-button');
        //         // this.hideGuideline();
        //     },
        // },
    ];

    private onResourceLoading() {
        this.setLoading(true);
    }

    private onResourceLoadingFinished() {
        this.setLoading(false);
    }

    private toogelWeekDay(event: Event): void {
        // event.target.nextElementSibling.classList.toggle('hidden');
        // event.target.previousElementSibling.classList.toggle('hidden');
        // event.target.parentElement.classList.toggle('hidding-weekday');
        // event.target.parentElement.style.height = '30px';
    }

    private toogleTicketSelection(ticketId: number) {
        this.toogleSelectedTicket(ticketId);
        // this.form.ParticipantData.SelectedTickets.Value = this.selectedTicketsIds;

        if (ticketId === this.masterPathId) {
            // Master Path
            this.form.IsForCouple = !this.form.IsForCouple;
        }

        this.selectedTicketsIds.forEach(x => console.log(this.getTicketTitle(x)));
        const reserveListTicketsSelected =
            this.selectedTicketsIds.filter(x => this.tickets.filter(t => t.Id == x && t.IsReserveList).length > 0)
                .length > 0;
        if (this.form.ParticipantData.SexTypeId.Value === 2 && reserveListTicketsSelected) {
            // Female
            this.form.IsForCouple = true;
        } else {
            this.form.IsForCouple = false;
        }
    }

    private toogleSexTypeIdSelection(sexTypeId: number) {
        this.selectedTicketsIds.forEach(x => console.log(this.getTicketTitle(x)));
        const reserveListTicketsSelected =
            this.selectedTicketsIds.filter(x => this.tickets.filter(t => t.Id == x && t.IsReserveList).length > 0)
                .length > 0;
        if (sexTypeId === 2 && reserveListTicketsSelected) {
            // Female
            this.form.IsForCouple = true;
        } else {
            this.form.IsForCouple = false;
        }
    }

    private toggleWorkshopSelection(eventTarget: EventTarget, workshop: Workshop): void {
        const workshopsElement = this.getWorkshopElement(workshop.Id);
        if (workshopsElement !== null && workshop.IncludedInTickets.length == 1) {
            workshop.IncludedInTickets.forEach(ticketId => this.toogleTicketSelection(ticketId));
        }
    }

    private pulsElement(id: string) {
        const element = document.getElementById(id);
        if (element !== null) {
            element.classList.add('pulsing');
        }
    }

    private unpulsElement(id: string) {
        const element = document.getElementById(`${id}`);
        if (element !== null) {
            element.classList.remove('pulsing');
        }
    }

    private getWorkshopElement(id: number | undefined): HTMLElement | null {
        return !id ? null : document.getElementById(`workshop_${id}`);
    }

    private getTicketElement(id: number | undefined): HTMLElement | null {
        return !id ? null : document.getElementById(`ticket_${id}`);
    }

    private get masterPathId() {
        const masterPaths = this.availableTicketsIds.filter(x => this.getTicketTitle(x) === 'Master Path');
        return masterPaths.length > 0 ? masterPaths[0] : 0;
    }

    private get marathonPassId() {
        const marathonPasses = this.availableTicketsIds.filter(
            x => this.getTicketTitle(x) === 'Party Pass' || this.getTicketTitle(x) === 'Party Pass Reserve List',
        );
        return marathonPasses.length > 0 ? marathonPasses[0] : 0;
    }

    private get selectedTicketsPriceSum() {
        const selectedTicketIds = this.selectedTicketsIds;
        const availableTicketsTypes = this.availableTicketsTypes;
        const getPrice = function(ticketId: number): number {
            const price = availableTicketsTypes.find(x => x.Id === ticketId)?.CurrentPrice;
            return price ? price : 0;
        };
        const totalPrice = selectedTicketIds.reduce((sum, current) => sum + getPrice(current), 0);

        return totalPrice;
    }

    private get availableTicketIds() {
        return [...new Set(this.availableTicketsTypes.map(x => x.Id))];
    }

    private get availableWorkshopIds(): number[] {
        return [...new Set(this.workshops.filter(x => x.Id).map(x => x.Id))];
    }

    private isTicketSelected(ticketId: number): boolean {
        return this.selectedTicketsIds.includes(ticketId);
    }

    private isWorkshopSelected(workshopId: number): boolean {
        return this.selectedWorkshopsIds.includes(workshopId);
    }

    private getImageUrl(url: string) {
        if (url === undefined) {
            return '';
        }
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    private totalNumberOfRooms(weekDays: WeekDay[]) {
        const rooms = weekDays
            .map((l: WeekDay) => l.Locations)
            .reduce((a, b) => a.concat(b), [])
            .map(l => l.Rooms)
            .reduce((a, b) => a.concat(b), []);

        return rooms.length;
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
